module.exports = __webpack_public_path__ + "static/media/yarn.d9e23af6.png";